import { render } from "./OnboardingPortal.vue?vue&type=template&id=813f9050&scoped=true"
import script from "./OnboardingPortal.vue?vue&type=script&lang=js"
export * from "./OnboardingPortal.vue?vue&type=script&lang=js"

import "./OnboardingPortal.vue?vue&type=style&index=0&id=813f9050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813f9050"]])

export default __exports__